export default __webpack_public_path__ + "static/char-v-16-1090851ce3757b04abe0b56c4b7b99be.webp";